import { render, staticRenderFns } from "./reviewApplication.vue?vue&type=template&id=4bce4f4e&scoped=true"
import script from "./reviewApplication.vue?vue&type=script&lang=js"
export * from "./reviewApplication.vue?vue&type=script&lang=js"
import style0 from "./reviewApplication.vue?vue&type=style&index=0&id=4bce4f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce4f4e",
  null
  
)

export default component.exports